// Случайная целая задержка в миллисекундах в диапазоне [min, max] включительно
export const getRandomDelayMs = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
